import { Action } from 'redux';
import { ProductType, ProductTypeAssortment, ProductTypesFilter, Ratings, Status } from '@/types';

export interface ProductTypesState {
  detail: Record<string, ProductType>;
  assortment: ProductTypeAssortment;
  assortmentStatus: Status;
  filter: ProductTypesFilter;
  ratings: Ratings;
}

export enum ProductTypesActionTypes {
  PRODUCT_TYPE_SET = '@product-types/set',
  PRODUCT_TYPES_ASSORTMENT_SET = '@product-types/assortment/set',
  PRODUCT_TYPES_ASSORTMENT_SET_STATUS = '@product-types/assortment/set-status',
  PRODUCT_TYPES_FILTER_SET = '@product-types/filter/set',
  PRODUCT_TYPES_RATINGS_SET = '@product-types/ratings/set',
}

export interface ProductTypesSetAction extends Action {
  type: ProductTypesActionTypes.PRODUCT_TYPE_SET;
  productType: ProductType;
}

export interface ProductTypesAssortmentSetAction extends Action {
  type: ProductTypesActionTypes.PRODUCT_TYPES_ASSORTMENT_SET;
  assortment: ProductTypeAssortment;
}

export interface ProductTypesAssortmentSetStatusAction extends Action {
  type: ProductTypesActionTypes.PRODUCT_TYPES_ASSORTMENT_SET_STATUS;
  status: Status;
}

export interface ProductTypesFilterSetAction extends Action {
  type: ProductTypesActionTypes.PRODUCT_TYPES_FILTER_SET;
  filter: ProductTypesFilter;
}

export interface ProductTypesRatingsSetAction extends Action {
  type: ProductTypesActionTypes.PRODUCT_TYPES_RATINGS_SET;
  ratings: Ratings;
}

export type ProductTypesActions =
  | ProductTypesSetAction
  | ProductTypesAssortmentSetAction
  | ProductTypesAssortmentSetStatusAction
  | ProductTypesFilterSetAction
  | ProductTypesRatingsSetAction;
